import { Link } from "react-router-dom";
import { ArrowLeft, EnvelopeSimple, ShieldCheck } from "@phosphor-icons/react";
import { useGet } from "@/hooks/useResource";
import { Loading } from "@/components/common";

export default function Privacy() {
  const { data, loading } = useGet("/privacy");
  if (loading) return <Loading label="Loading" />;

  return (
    <div className="grain-bg min-h-screen">
      <div className="max-w-4xl mx-auto px-6 py-12 sm:py-20">
        <Link to="/login" data-testid="privacy-back-link" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors duration-200 mb-8">
          <ArrowLeft size={18} /> Back
        </Link>
        <p className="eyebrow text-accent">Gledswood Homestead + Winery</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-light tracking-tight text-primary mt-2">{data?.title}</h1>
        <p className="mt-3 text-sm text-muted-foreground" data-testid="privacy-effective-date">Effective Date: {data?.effective_date}</p>
        <p className="mt-6 max-w-3xl text-base leading-relaxed text-primary" data-testid="privacy-introduction">{data?.introduction}</p>
        <section className="mt-8 border-y border-border py-6" data-testid="privacy-deletion-request">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <div className="flex items-center gap-2"><ShieldCheck size={20} className="text-secondary" /><p className="eyebrow">Privacy choices</p></div>
              <p className="mt-2 text-sm text-muted-foreground">Request review of a personal-information deletion request through Gledswood.</p>
            </div>
            <a href="mailto:events@gledswood.com.au?subject=Personal%20information%20deletion%20request" data-testid="request-data-deletion-link" className="inline-flex items-center justify-center gap-2 rounded-full border border-border px-4 py-2 text-sm text-primary hover:bg-muted transition-colors duration-200"><EnvelopeSimple size={17} /> Request data deletion</a>
          </div>
        </section>
        <div className="mt-8 space-y-10">
          {(data?.sections || []).map((s, i) => (
            <section key={i} data-testid={`privacy-section-${i + 1}`}>
              <h2 className="font-heading text-2xl text-primary">{s.heading}</h2>
              {s.body && <p className="text-muted-foreground mt-2 leading-relaxed">{s.body}</p>}
              {s.bullets?.length > 0 && <ul className="mt-3 list-disc space-y-1 pl-5 text-sm leading-relaxed text-muted-foreground">{s.bullets.map((bullet) => <li key={bullet}>{bullet}</li>)}</ul>}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
